import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '精彩片花', href: '#media' },
  { label: '常见问题', href: '#faq' },
  { label: '热门话题', href: '#topics' },
  { label: '精选推荐', href: '#cards' },
  { label: 'APP下载', href: '#app' },
  { label: '平台优势', href: '#features' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a href="#hero" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-clapperboard-fill text-background-50 text-lg"></i>
            </span>
            <span className="text-xl font-heading font-bold text-foreground-950 hidden sm:block">
              番茄影视大全
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-lg hover:bg-primary-50 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200 cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <nav className="md:hidden pb-4 border-t border-background-200/60 pt-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}